import React, { FormEvent } from 'react';
import theme, { styled } from '@/styles/theme';
import DNBoxInput from '@/components/DNBoxInput';
import SelectComponent from '@/components/SelectComponent';
import { ReactComponent as Delete } from '@/assets/images/order/delete.svg';
import { useEmergencyFormViewModel } from '@/pages/OrderDetailPage/containers/EmergencyMessageFormViewModel';

interface Props {
  orderId: number;
  onClickClose: () => void;
}

const EmergencyMessageForm = (props: Props) => {
  const { onClickClose, orderId } = props;
  const { form, options, ...viewModel } = useEmergencyFormViewModel({
    orderId
  });

  const onChangeReason = (e: FormEvent<HTMLInputElement>) => {
    viewModel.inputReason((e.target as HTMLInputElement).value);
  };

  const onChangePharmacyPhone = (e: FormEvent<HTMLInputElement>) => {
    viewModel.inputPharmacyPhone((e.target as HTMLInputElement).value);
  };

  const onSubmit = async () => {
    try {
      await viewModel.submit();
      onClickClose();
    } catch (error) {
      alert((error as Error).message);
    }
  };

  return (
    <Wrapper
      onMouseMove={e => {
        e.stopPropagation();
      }}>
      <TitleRow>
        <Title>긴급 연락 보내기</Title>
        <Delete style={{ cursor: 'pointer' }} onClick={onClickClose} />
      </TitleRow>
      <DescriptionRow>
        의사 선생님 개인 연락처로 연락을 요청하는 문자를 보내요.
        <br />
        처방전에 기재된{' '}
        <DescriptionHighLight>
          병원 번호로 연락이 어려울 때만 사용
        </DescriptionHighLight>
        해주세요
      </DescriptionRow>
      <Col>
        <SubTitle>연락 사유</SubTitle>
        {options && (
          <SelectComponent
            isSearchable={false}
            selectStyle={{
              width: '100%',
              marginBottom: 6,
              borderRadius: 12,
              padding: 5,
              height: 60,
              background: theme.DF_COLOR.GRAY10,
              border: `1px solid ${theme.DF_COLOR.GRAY50}`,
              fontSize: 18
            }}
            indicatorStyle={{ display: 'none' }}
            options={options}
            defaultValue={options[0]}
            onChange={viewModel.changeReasonId}
          />
        )}
        {viewModel.manualReasonSelected() && (
          <DNBoxInput
            maxLength={255}
            style={{ height: 60, width: '100%' }}
            value={form.reason}
            onChange={onChangeReason}
            onClear={viewModel.clearReason}
          />
        )}
      </Col>
      <SubTitle>연락 받을 번호</SubTitle>
      <DNBoxInput
        maxLength={20}
        onChange={onChangePharmacyPhone}
        value={form.pharmacyPhone}
        style={{ height: 60, width: '100%' }}
      />
      <Button onClick={onSubmit}>보내기</Button>
    </Wrapper>
  );
};

export default EmergencyMessageForm;

const Wrapper = styled.div`
  padding: 24px;
`;

const TitleRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const Title = styled.span`
  ${({ theme }) => theme.DF_TYPOGRAPHY.UI24SB};
`;

const DescriptionRow = styled.div`
  ${({ theme }) => theme.DF_TYPOGRAPHY.UI16R};
  color: ${({ theme }) => theme.DF_COLOR.GRAY400};
  margin-top: 12px;
  margin-bottom: 12px;
`;

const DescriptionHighLight = styled.span`
  color: ${({ theme }) => theme.DF_COLOR.PRIMARY700};
`;

const SubTitle = styled.div`
  ${({ theme }) => theme.DF_TYPOGRAPHY.UI14M};
  color: ${({ theme }) => theme.DF_COLOR.GRAY600};
  margin-top: 20px;
  margin-bottom: 6px;
`;

const Button = styled.div`
  border-radius: 12px;
  padding: 17px 0;
  width: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: ${({ theme }) => theme.DF_COLOR.PRIMARY500};
  color: ${({ theme }) => theme.DF_COLOR.WHITE};
  ${({ theme }) => theme.DF_TYPOGRAPHY.UI18SB};
  margin-top: 32px;
  margin-left: auto;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
  width: 432px;
`;
